import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { ConsultaPlanoFamiliaComponent } from './consulta-plano-familia.component';
import { TableModule } from 'primeng/table';
import { DropdownModule } from 'primeng/dropdown';
import { TooltipModule } from 'primeng/tooltip';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { OsModule } from '../../rmpv/rmpv-detalhado-os/os.module';
import { ChartsModule } from 'ng2-charts';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { InputTextModule } from 'primeng/inputtext';
import { ProgressBarModule } from 'primeng/progressbar';
import { DialogModule } from 'primeng/dialog';
import { ContextMenuModule } from 'primeng/contextmenu';
import { MultiSelectModule } from 'primeng/multiselect';
import { SliderModule } from 'primeng/slider';
import { CalendarModule } from 'primeng/calendar';
import { ToastModule } from 'primeng/toast';
import { ButtonModule } from 'primeng/button';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { TreeTableModule } from 'primeng/treetable';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { translateLoaderNBS } from '../../../shared/translate-loader/translateLoader';
import { TranslateModule } from '@ngx-translate/core';
import { PlanoFamiliaFiltrosService } from './plano-familia-filtros.service';
import { ComumModule } from '../../../shared/comum.module';
import { PlanoFamiliaService } from './plano-familia.service';

@NgModule({
  imports: [
    HttpClientModule,
    BrowserAnimationsModule,
    TreeTableModule,
    TableModule,
    ToggleButtonModule,
    ButtonModule,
    ToastModule,
    CalendarModule,
    SliderModule,
    MultiSelectModule,
    ContextMenuModule,
    DialogModule,
    DropdownModule,
    ProgressBarModule,
    InputTextModule,
    FormsModule,
    CommonModule,
    BrowserModule,
    ReactiveFormsModule,
    ChartsModule,
    OsModule,
    NgbModule,
    ComumModule,
    TranslateModule.forRoot(translateLoaderNBS),
    TooltipModule
  ],
  declarations: [
    ConsultaPlanoFamiliaComponent
  ],
  providers: [
    PlanoFamiliaFiltrosService,
    PlanoFamiliaService,
    DatePipe
  ]
})

export class ConsultaPlanoFamiliaModule { }
